// Page détail d'une offre : en desktop, quand le CTA de l'en-tête sort de l'écran,
// la barre .offer-sticky remplace la navigation du site (classe offer-sticky-on sur <body>, voir _offer-header.scss).
// En mobile la barre est toujours visible en bas de l'écran (CSS seul).
(function (document) {
    document.addEventListener("DOMContentLoaded", function () {
        const action = document.querySelector('.offer-header-action');
        const sticky = document.querySelector('.offer-sticky');
        const headerNav = document.querySelector('#header-navigation');

        if (!action || !sticky || !headerNav || !('IntersectionObserver' in window)) {
            return;
        }

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                // Uniquement quand le CTA est passé au-dessus de l'écran, pas quand il est encore en dessous
                const isPast = !entry.isIntersecting && entry.boundingClientRect.top < entry.rootBounds.top;
                document.body.classList.toggle('offer-sticky-on', isPast);
            });
        }, {
            rootMargin: '-' + headerNav.offsetHeight + 'px 0px 0px 0px'
        });

        observer.observe(action);
    });
})(document);
